'use client'
import {
  useEditableContext
} from "./chunk-WYY72ITE.mjs";

// src/use-editable-controls.tsx
function useEditableControls() {
  const {
    isEditing,
    getEditButtonProps,
    getCancelButtonProps,
    getSubmitButtonProps
  } = useEditableContext();
  return {
    isEditing,
    getEditButtonProps,
    getCancelButtonProps,
    getSubmitButtonProps
  };
}

export {
  useEditableControls
};
//# sourceMappingURL=chunk-OKWGAP7R.mjs.map